import React from "react";
import { SnackbarKey, SnackbarProvider } from "notistack";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

interface Props {
  children: React.ReactNode;
}
export function RootLayout(props: Props) {
  // add action to all snackbars
  const notistackRef = React.createRef<SnackbarProvider>();

  function onClickDismiss(key: SnackbarKey) {
    notistackRef?.current?.closeSnackbar(key);
  }

  return render();

  function render() {
    return (
      <SnackbarProvider
        maxSnack={3}
        ref={notistackRef}
        action={(key: SnackbarKey) => (
          <IconButton onClick={() => onClickDismiss(key)} size="large">
            <Close />
          </IconButton>
        )}
      >
        {props.children}
      </SnackbarProvider>
    );
  }
}
